/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('GitToClipboardController', function($scope, copyToClipboard) {
    $scope.toClipboard = copyToClipboard.copy;
    $scope.protocol    = 'ssh';
    const splitted           = $scope.rendu.split('https://')[1].split('/');
    const domain             = splitted.shift();
    // si rendu-svn est présent, search va retourner 0 (index)
    let ssh                = domain.search(/rendu-svn/) === 0 ? `svn+ssh://${domain}/` : `git@${domain}:`;
    ssh               += splitted.join('/');

    $scope.adresses = {
        https: $scope.rendu,
        ssh
    };

    // toggle du protocol + mise a jour du rendu
    return $scope.switchProtocol = () => $scope.protocol = $scope.protocol === 'https' ? 'ssh' : 'https';
});
